import { ErrorPrompt404 } from '@karnov/kui-react'

import type { FC } from 'react'

export const ErrorPageNotFound: FC = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <ErrorPrompt404 locale="en" />
  </div>
)
